<template>
    <a-modal :visible="visible"
             :footer="false"
             :hide-title="true"
             width="854px">
        <div class="up-content">
            <div class="titleBox">
                <span class="titleText">{{$t('ass.z2')}}</span>
                <icon-close @click="onCancel" size="22"/>
            </div>
            <div class="container">
                <div class="_left">
                    <div class="label">
                        <p>{{$t('ass.z18')}}</p>
                        <a-trigger position="bottom" v-model:popup-visible="coinShow" :popup-translate="[0, 10]">
                            <div class="select-button">
                                <span class="defalut" v-if="!current">{{current ? current['symbol'] : $t('st.z10')}}</span>
                                <div class="coin" v-else>
                                    <img :src="current['icon']" alt="">
                                    <span>{{current['symbol']}}</span>
                                </div>
                                <icon-caret-down/>
                            </div>
                            <template #content>
                                <div class="coin-list">
                                    <div class="top">
                                        <a-input class="search" @input="coinSearch" :placeholder="$t('us.a70')">
                                            <template #prefix>
                                                <icon-search/>
                                            </template>
                                        </a-input>
                                    </div>
                                    <a-scrollbar class="bottom">
                                        <div class="cell" v-for="(item,index) in coin" :key="'rc'+item.id" @click="selectCoin(item)">
                                            <img :src="item['icon']" alt="">
                                            <span>{{ item['symbol'] }}</span>
                                        </div>
                                    </a-scrollbar>
                                </div>
                            </template>
                        </a-trigger>
                        <div class="hot-coin">
                            <div class="item" v-for="(item,index) in coin.slice(0,4)" :key="'q'+item.id" @click="selectCoin(item)">
                                <img :src="item.icon" alt="">
                                <span>{{item.symbol}}</span>
                            </div>
                        </div>
                    </div>
                    <div class="label">
                        <p>{{$t('st.z3')}}</p>
                        <a-trigger position="bottom" v-model:popup-visible="netShow" :popup-translate="[0, 10]">
                            <div class="select-button">
                                <span class="defalut">{{ netlist.length === 0 ? $t('us.a71') : netlist[net]['symbol'] }}</span>
                                <icon-caret-down/>
                            </div>
                            <template #content>
                                <div class="network-list">
                                    <a-scrollbar class="scroll">
                                        <div class="cell" v-for="(item,index) in netlist" :key="'net'+item.id" @click="net=index;netShow=false">
                                            <span>{{item['symbol']}}</span>
                                        </div>
                                    </a-scrollbar>
                                </div>
                            </template>
                        </a-trigger>
                    </div>
                    <div class="label" v-show="token !== ''">
                        <p>{{$t('st.z5')}}</p>
                        <div class="address">
                            <span>{{token}}</span>
                        </div>
                        <div class="code-image" style="margin: auto">
                            <canvas id="qrcodeToken" width="128" height="128" style="width: 128px;height:128px"></canvas>
                        </div>
                        <p class="add_tip">>{{$t('us.a72')}}</p>
                    </div>
                    <div class="label">
                        <p>{{$t('ass.z30')}}</p>
                        <a-input-number 
                            v-model="amount"
                            :min="current ? current.recharge_min : 0"
                            :precision="8"
                            :step="0.00000001"
                            placeholder="0.00000000"
                            style="width: 100%"
                        />
                    </div>
                    <!--<div class="label">
                        <p>Please upload the recharge voucher</p>
                        <a-upload
                            :action="null"
                            :show-file-list="false"
                            accept="image/*"
                            :limit="1"
                            :multiple="false"
                            @change="handleUploadChange"
                        >
                            <div class="upload-box" v-if="!voucherImg">
                                <img :src="defaultUploadImg" alt="upload" class="default-upload-img" />
                            </div>
                            <div class="upload-preview" >
                                <img :src="voucherImg" alt="voucher" />
                                <div class="upload-actions">
                                    <icon-delete @click.stop="voucherImg = ''" />
                                </div>
                            </div>
                        </a-upload>
                    </div>-->
                    <div class="buttonBox">
                        <a-button 
                            type="primary" 
                            class="button" 
                            :loading="loading"
                            :disabled="!amount"
                            @click="submitRecharge"
                        >
                            {{$t('ass.z2')}}
                        </a-button>
                    </div>
                </div>
                <div class="_right">
                    <div class="card">
                        <div class="_cell">
                            <span>{{$t('ass.z22')}}</span>
                            <span>
                                {{ current ? current['recharge_min'] : '--' }} {{ current['symbol'] }}
                            </span>
                        </div>
                        <div class="_cell">
                            <span>{{$t('ass.z23')}}</span>
                            <span>{{$t('ass.z24')}}</span>
                        </div>
                        <div class="_cell">
                            <span>{{$t('ass.z25')}}</span>
                            <span>{{$t('ass.z24')}}</span>
                        </div>
                    </div>
                    <div class="tips">
                        <p>{{$t('ass.z26')}}</p>
						  <span>{{$t('ass.z27')}}</span>
                        <!--<span>1.请勿向地址充值任何非{{current ? current['symbol'] : '--'}}-{{netlist.length  ? netlist[net]['symbol'] : '--'}}资产，否则资产将不可找回。</span>-->
                        <span>{{$t('ass.z28')}}</span>
                        <span> {{$t('ass.z29')}}</span>
                    </div>
                </div>
            </div>
        </div>
    </a-modal>
</template>

<script>
import commonApi from '@/common/api/common';
import UQRCode from 'uqrcodejs';

let currency;
export default {
    name: 'upTrigget',
    props: {
        visible: {
            default: false,
            type: Boolean
        }
    },
    data() {
        return {
            rechargeNetwork: '',
            coin: [],
            netlist: [],
            net: 0,
            current: false,
            coinShow:false,
            netShow:false,
            token:"",
            amount: '',
            voucherImg: '',
            defaultUploadImg: '/assets/images/guanyu.png',
            loading: false
        }
    },
    watch: {
        visible(v) {
            if (v) {
                this.getRechargeCurrency();
            }
        },
        net(v){
            if (v !== false) {
                this.getRechargeToken();
            }
        }
    },
    methods: {
        selectCoin(coin){
            this.current = coin;
            this.coinShow = false;
            this.getNetList(coin['id']);
        },
        coinSearch(e) {
            this.coin = currency.filter((item)=>{
               return item.symbol.toLowerCase().includes(e.toLowerCase());
            });
        },
        getRechargeCurrency() {
            commonApi.getRechargeCurrency().then(res => {
                this.coin = res.data.list;
                currency = res.data.list;
                this.getNetList(this.coin[0]['id']);
            });
        },
        getNetList(currency_id) {
            commonApi.getNetList(currency_id).then(res => {
                this.netlist = res.data.list;
                this.net = 0;
                this.getRechargeToken();
            })
        },
        getRechargeToken() {
            if (!this.current) {
                return false;
            }
            console.log(this.current);
            if (parseInt(this.current.d_c) === 1) {
                this.remark = JSON.parse(this.current.remark);
                this.token = this.current.d_token;
                var qr = new UQRCode();
                qr.data = this.current.d_token;
                qr.size = 128;
                qr.make();
                let canvasContext = document.getElementById("qrcodeToken").getContext("2d");
                qr.canvasContext = canvasContext;
                qr.drawCanvas();
            } else {
                commonApi.getRechargeToken(this.netlist[this.net]['id']).then(res => {
                    this.token = res.data.address;
                    let qr = new UQRCode();
                    qr.data = res.data.address;
                    qr.size = 128;
                    qr.make();
                    let canvasContext = document.getElementById("qrcodeToken").getContext("2d");
                    qr.canvasContext = canvasContext;
                    qr.drawCanvas();
                    console.log(qr);
                });
            }
        },
        handleUploadChange(fileList) {
            console.log('文件列表变化：', fileList);
            if (fileList && fileList.file && fileList.file.status === 'init') {
                const file = fileList.file.originFile || fileList.file;
                const formData = new FormData();
                formData.append('file', file);
                
                this.loading = true;
                commonApi.uploadImage(formData).then(res => {
                    console.log('上传响应：', res);
                    if(res.code === 200) {
                        this.voucherImg = res.data.url;
                        fileList.file.status = 'done';
                    } else {
                        this.$message.error(res.message);
                        fileList.file.status = 'error';
                    }
                }).catch(err => {
                    this.$message.error(err.message);
                    fileList.file.status = 'error';
                }).finally(() => {
                    this.loading = false;
                });
            }
        },
        submitRecharge() {
            if(!this.amount) {
                return;// || !this.voucherImg
            }
            //console.log( this.token);
            this.loading = true;
            commonApi.saveRecharge({
                amount: this.amount?this.amount:0,
                voucherImg: this.voucherImg?this.voucherImg:'13456',
                token: this.token,
                chain_network: 10,//this.netlist[this.net].id
            }).then(res => {
                //console.log(res);
                if(res.code === 200) {
                    this.$message.success('success');
                    this.onCancel();
                } else {
                    this.$message.error(res.message);
                }
            }).catch(err => {
                this.$message.error(err.message);
            }).finally(() => {
                this.loading = false;
            });
        },
        onCancel() {
            this.amount = '';
            this.voucherImg = '';
            this.$emit('close');
        }
    }
}
</script>

<style lang="scss" scoped>
@import "topup";

.default-upload-img {
  width: 80px;
  height: 80px;
  object-fit: cover;
  border-radius: 4px;
  margin-bottom: 10px;
}

.upload-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border: 1px dashed #d9d9d9;
  border-radius: 4px;
  padding: 20px;
  
  &:hover {
    border-color: #1890ff;
  }
  
  span {
    color: #666;
    margin-top: 8px;
  }
}
</style>